<template>
  <div>
    <h2>Research Citation Links</h2>
    <div
      class="panel-body"
      v-for="researchCitation in researchCitations"
      :key="researchCitation.uuid">
      <p class="citation">
        <tooltip
          :text="'Resources can be accessed with a district or school membership.'"
          v-if="shouldBlockLink">
          <a>{{ researchCitation.citation }}</a>
        </tooltip>
        <a
          v-else
          :href="researchCitation.source_link"
          target="_blank"
          @click="clickedResearchLink(researchCitation)">{{ researchCitation.citation }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACTION_TYPES, CONTENT_TYPES, actionPermissions } from '@/util/access_visibility'

export default {
  name: 'ResearchCitationPanels',
  props: {
    researchCitations: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('user', ['authInfo']),
    ...mapGetters({
      beta: 'visibility/betaVisibility'
    }),
    shouldBlockLink() {
      return actionPermissions(ACTION_TYPES.FOLLOW_LINK, CONTENT_TYPES.STRATEGY, {}, this.authInfo)
        .block
    }
  },
  methods: {
    clickedResearchLink(researchCitation) {
      this.$sendEvent('Clicked Research Citation', {
        research_citation_uuid: researchCitation.uuid,
        research_citation_title: researchCitation.title
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';

h2 {
  font-weight: bold;
}

.panel-body {
  font-size: 16px;
  line-height: 25px;
  padding: 0px 24px;
}
.citation {
  margin-left: 36px;
  text-indent: -36px;
  overflow-wrap: break-word;
  a {
    &:after {
      font-family: 'FontAwesome';
      content: ' \F08E';
      font-size: 75%;
    }
  }
}
</style>
